import { render, staticRenderFns } from "./activityLogEventList.vue?vue&type=template&id=5da89ba5&"
import script from "./activityLogEventList.vue?vue&type=script&lang=js&"
export * from "./activityLogEventList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports